import { render } from "./CircleNoneRadialIcon.vue?vue&type=template&id=9ef3d0d4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__